
import { Component, Vue } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import DropDown from '@/common/dropdown.vue';
import { validatePassWord } from '@/tools/regexp';
import {
  updatePasswordNew,
  getCode,
  updateMobileNo,
  untypingWechat
} from '@/services/http';
// import { writeCookie } from '@/tools/tools';
@Component({
  components: {
    Header,
    Price,
    Footer,
    DropDown,
    NavMenu
  }
})
export default class extends Vue {
  validateCheckPass = (rule: any, value: string, callback: any) => {
    if (value === '') {
      callback(new Error('请再次输入密码'));
    } else if (value !== this.form.newPassword) {
      callback(new Error('两次输入密码不一致!'));
    } else {
      callback();
    }
  }

  infoList: any = {}

  form: any = {
    oldPassword: '',
    newPassword: '',
    checkPass: ''
  }

  telform: any = {
    mobileNo: '',
    smsCode: ''
  }

  rules: object = {
    mobileNo: [{ required: true, message: '请输入电话号码', trigger: 'blur' }],
    smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
    oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
    newPassword: [{ validator: validatePassWord, trigger: 'blur' }],
    checkPass: [{ validator: this.validateCheckPass, trigger: 'blur' }]
  }

  dialogVisible: boolean = false

  telDialog: boolean = false

  @State('user') userinfor: any;

  @Action('user/setUserInfoList') setUserInfoList!: Function;

  created() {
    this.getUserInfo();
  }

  changePassword() {
    this.dialogVisible = true;
    this.$nextTick(() => {
      const form = this.$refs.form as any;
      form.resetFields();
      this.telform = {
        mobileNo: '',
        smsCode: ''
      };
    });
  }

  changeTel() {
    this.telDialog = true;
    this.$nextTick(() => {
      const form = this.$refs.telform as any;
      form.resetFields();
      this.form = {
        oldPassword: '',
        newPassword: '',
        checkPass: ''
      };
    });
  }

  // 重置密码
  private async setPassword() {
    const form = this.$refs.form as any;
    form.validate(async (valid: boolean) => {
      if (valid) {
        const res: any = await updatePasswordNew(this.form);
        if (res.data.code === 100) {
          this.$message.success('更换密码成功！');
          this.dialogVisible = false;
          //  this.setUserInfoList();
          //  writeCookie('accessToken', res.data.data);
          //  const path: any = this.$route.query.redirect;
          //  if (path) {
          //    this.$router.push(path);
          //  } else {
          //    this.$router.push('/');
          //  }
        } else {
          this.$message.error(res.data.message);
        }
      }
    });
  }

  // 获取个人信息
  private async getUserInfo() {
    this.setUserInfoList();
  }

  // 解绑微信
  private async untypingWechat() {
    const res:any = await untypingWechat();
    if (res.data.code === 100) {
      this.$message.success('解绑成功');
    } else {
      this.$message.error(res.data.message);
    }
  }

  // 绑定手机号码
  private async setTelPhone() {
    const form = this.$refs.telform as any;
    form.validate(async (valid: boolean) => {
      if (valid) {
        const res: any = await updateMobileNo(this.telform);
        if (res.data.code === 100) {
          this.telDialog = false;
          this.$message.success('绑定手机号码成功！');
        } else {
          this.$message.error(res.data.message);
        }
      }
    });
  }

  // 获取验证码
  private async getCode() {
    const res: any = await getCode({ phone: this.telform.mobileNo, src: 3 });
    if (res.data.code === 100) {
      this.$message.success('手机验证码已经成功发送，请注意查收！');
      // this.endTime = Date.now() + 59 * 1000;
      // this.isCountDown = true;
      // this.clsStyle = false;
    } else {
      this.$message.error(res.data.message);
    }
  }

  private async modifyTelphone() {
    const res: any = await updateMobileNo({
      mobileNo: '',
      smsCode: ''
    });
    if (res.data.code === 100) {
      this.$message.error('绑定手机号码成功！');
      this.$router.back();
    } else {
      this.$message.error(res.data.message);
    }
  }
}
